import {
  //
  ADD_TOC,
  ADD_TOC_FAILURE,
  ADD_TOC_SUCCESS,
  //
  DELETE_TOC,
  DELETE_TOC_FAILURE,
  DELETE_TOC_SUCCESS,
  //
  EDIT_TOC,
  EDIT_TOC_FAILURE,
  EDIT_TOC_SUCCESS,
  //
  FETCH_TOC,
  FETCH_TOC_FAILURE,
  FETCH_TOC_SUCCESS,
  //
  GET_VIEW_DATA,
  GET_VIEW_DATA_FAILURE,
  GET_VIEW_DATA_SUCCESS,
} from "./constants";

// List
export const fetchTOC = (payload) => ({
  type: FETCH_TOC,
  payload,
});
export const fetchTOCSuccess = (payload) => ({
  type: FETCH_TOC_SUCCESS,
  payload,
});
export const fetchTOCFailure = (payload) => ({
  type: FETCH_TOC_FAILURE,
  payload,
});
// View
export const getViewData = (payload) => ({
  type: GET_VIEW_DATA,
  payload,
});
export const getViewDataSuccess = (payload) => ({
  type: GET_VIEW_DATA_SUCCESS,
  payload,
});
export const getViewDataFailure = (payload) => ({
  type: GET_VIEW_DATA_FAILURE,
  payload,
});
// ADD
export const addTOC = (payload) => ({
  type: ADD_TOC,
  payload,
});
export const addTOCSuccess = (payload) => ({
  type: ADD_TOC_SUCCESS,
  payload,
});
export const addTOCFailure = (payload) => ({
  type: ADD_TOC_FAILURE,
  payload,
});
// EDIT
export const editTOC = (payload) => ({
  type: EDIT_TOC,
  payload,
});
export const editTOCSuccess = (payload) => ({
  type: EDIT_TOC_SUCCESS,
  payload,
});
export const editTOCFailure = (payload) => ({
  type: EDIT_TOC_FAILURE,
  payload,
});
// DELETE
export const deleteTOC = (payload) => ({
  type: DELETE_TOC,
  payload,
});
export const deleteTOCSuccess = (payload) => ({
  type: DELETE_TOC_SUCCESS,
  payload,
});
export const deleteTOCFailure = (payload) => ({
  type: DELETE_TOC_FAILURE,
  payload,
});
